import React from 'react';
import Form from 'antd/lib/form';
import 'antd/lib/form/style/index.css';
import Input from 'antd/lib/input';
import 'antd/lib/input/style/index.css';
var InputId = function (props) { return (React.createElement(Form.Item, { label: 'Document ID', colon: false },
    React.createElement(Input, { size: 'large', value: props.initialValue, readOnly: true, disabled: props.isDisabled }))); };
export default InputId;



//////////////////
// WEBPACK FOOTER
// ./src/pages/components/forms/InputId.tsx
// module id = 439
// module chunks = 0